import React from 'react';
import '../styles/pending.css';
import leftImage from '../assets/landing1.png';
import clockImage from '../assets/clockicon.png';

const Pending = () => {
    const handleGoToLogin = () => {
        console.log('Go to Login clicked');
        // Add your navigation logic here when needed
    };

    return (
        <div className="pending-page">
            {/* Left Image Section */}
            <div className="left-side">
                <img src={leftImage} alt="Lingayath Weds" className="left-image" />
            </div>

            {/* Right Pending Section */}
            <div className="right-side">
                <div className="pending-card">
                    <h1 className="title">Welcome to Lingayath Weds</h1>
                    
                    <div className="pending-content">
                        {/* Clock Icon */}
                        <div className="icon-container">
                            <img src={clockImage} alt="Pending" className="pending-icon" />
                        </div>

                        {/* Pending Message */}
                        <div className="pending-messages">
                            <p className="pending-message">
                                Your registration is pending approval.<br />
                                Please contact the administrator.
                            </p>
                            <p className="pending-message2">
                                You'll receive a WhatsApp message once approved.
                            </p>
                        </div>

                        {/* Go to Login Button */}
                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pending;